import React, { useState, useEffect } from 'react'
import "./Holidays.css"
import Reusabletable from '../../../register/FormInputs/reusableforms/Reusabletable'
import EditableTable from '../../../reUsableTemplates/EditableTable/EditableTable'
import ImportFileform from '../../../reUsableTemplates/ImportFileform/ImportFileform'
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import files from "./../../../../assets/templates/global_template/Holidays.xlsx"
import { multiDeleteHolidays, uploadHolidaysFile, deleteHolidaysById, updateHolidaysById, getHolidays } from './../../../../services/global_redux/globale_actions/Holidays.action';
import { getCurrentMonth } from './../../../../services/global_redux/globale_actions/Currentmonth.action'
import { getUserRole} from "./../../../../services/global_redux/globale_actions/Role.action"


import mainicon from "../../../../assets/global_assets/holiday_table/table_main_icon.png"
import current_month_icon from "../../../../assets/global_assets/holiday_table/current_month.png"
import holiday_name_icon from "../../../../assets/global_assets/holiday_table/holiday_name.png"
import holiday_type_icon from "../../../../assets/global_assets/holiday_table/holiday_type.png"
import state_icon from "../../../../assets/global_assets/holiday_table/state.png"
import date_icon from "../../../../assets/global_assets/holiday_table/date.png"

function Holidays({ setLoading, showSnackbar }) {
  const [getData, setGetData] = useState([])
  const [file, setFile] = useState([])
  const [editableRow, setEditableRow] = useState(null);
  const [editedValues, setEditedValues] = useState({})
  const [useMonth, setUseMonth] = useState([]);
  const dispatch = useDispatch();
  const { date } = useParams();
  const [checkCreate, setCheckCreate] = useState(false);
  const [checkEdit, setCheckEdit] = useState(false);
  const [checkDelete, setCheckDelete] = useState(false);  
  const [selectedState, setSelectedState] = useState("");
  const [filteredData, setFilteredData] = useState(getData);

  const header = [
    { key: "hol_state", value: "State", input: "state", icon: state_icon, dataIcon: true, highlightName: false },
    { key: "hol_name", value: "Holiday Name", input: "text", icon: holiday_name_icon, dataIcon: false, highlightName: false },
    { key: "hol_date", value: "Date", input: "date", icon: date_icon, dataIcon: false, highlightName: false },
    { key: "hol_type", value: "Holiday Type", input: "text", icon: holiday_type_icon, dataIcon: false, highlightName: true  },
    { key: "current_year", value: "Current Year", input: "text", icon: current_month_icon , dataIcon: false, highlightName: false}
  ];

  const [actionChecked, setActionChecked] = useState("");
  

  const fetchcurrmonth = async () => {
    try 
    {
      const response = await dispatch(getCurrentMonth());
      const currentMonth = new Date(response.data[0].current_month);

      const currentYear = getYearFromDate(currentMonth);
      setUseMonth(currentYear);

    } catch (err) {
      console.error("Failed to fetch current month:", err);
    }
  };

  // Function to extract the year from a Date object
  const getYearFromDate = (date) => {
    if (date instanceof Date && !isNaN(date)) {
      return date.getFullYear();  // Extract and return the year (e.g., 2024)
    } else {
      console.error("Invalid Date object provided.");
      return null;
    }
  };
  const fetchdata = async () => {
    // if (useMonth) {
      const currentYear = 2 ;
      console.log("Fetching holidays for the year:", currentYear);

      try {
        const response = await dispatch(getHolidays(currentYear));  // Dispatch action to get holidays for the current year
        if (response.data) {
          // Map hol_type to descriptive text
          const transformedData = response.data.map(holiday => ({
            ...holiday,
            hol_type: holiday.hol_type === 1 ? 'National Holiday' : 'Festival Holiday'
          }));

          setGetData(transformedData);
          setFilteredData(transformedData);
          setSelectedState('');
        } else {
          setGetData([]);
        }
      } catch (err) {
        console.error("Failed to fetch holiday data:", err);
      }
    // }
  };
  const filterstatewiseData = (event) => {
    const value = event.target.value;
    setSelectedState(value);
  
    if (value === "") {
      setFilteredData(getData); 
    } else {
      setFilteredData(getData.filter(item => item.hol_state === value));
    }
  };
  useEffect(() => {
    if (useMonth) {
      fetchdata();
    }
  }, [useMonth]);

  useEffect(() => {
    fetchcurrmonth();
    fetchdata();
  }, [dispatch]);

  // const handleFileUpload = async () => {
  //   if (file) {
  //     setLoading(true);

  //     const formData = new FormData();
  //     formData.append('file', file);
  //     try {
  //       const response = await dispatch(uploadHolidaysFile(formData));
  //       if (response.success == true) {
  //         showSnackbar(response.message.data.data.message, 'success');
  //         setLoading(false);
  //         fetchdata();
  //         setFile(null);
  //       } else {
  //         showSnackbar(response.message, 'warning');
  //         setLoading(false);
  //       }
  //     } catch (error) {
  //       showSnackbar('An error occurred', 'error');
  //       setLoading(false);
  //     }
  //   }
  // };
  


const downloadBase64Excel = (contentBase64, filename) => {
    try {
        // Decode base64 to binary
        const byteCharacters = atob(contentBase64);
        const byteNumbers = new Array(byteCharacters.length);
        
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { 
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
        });
        
        // Create download link
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename || 'holidays_failed_rows.xlsx';
        document.body.appendChild(a); // Required for Firefox
        a.click();
        
        // Cleanup
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
        
        console.log('Error file downloaded successfully:', filename);
    } catch (e) {
        console.error('Download failed:', e);
        showSnackbar('Failed to download error file. Please try again.', 'error');
    }
};

const handleFileUpload = async () => {
    if (!file) {
        showSnackbar('Please select a file to upload', 'warning');
        return;
    }
    
    setLoading(true);
    
    try {
        const response = await dispatch(uploadHolidaysFile(file));
        console.log("Upload holidays response:", response);
        
        // ============================================================
        // HANDLE SUCCESS RESPONSE (status 200)
        // ============================================================
        if (response.success === true) {
            const data = response.data; // This is the backend response object
            
            setActionChecked("create");
            // Check if we have the expected response structure
            if (!data) {
                showSnackbar('Unexpected response format', 'error');
                setLoading(false);
                return;
            }
            
            // Extract counts
            const insertedCount = data.inserted_count || 0;
            const failedCount = data.failed_count || 0;
            const totalRows = insertedCount + failedCount;
            
            // CASE 1: Full success (all rows inserted)
            if (insertedCount > 0 && failedCount === 0) {
                showSnackbar(
                    data.message || `Successfully uploaded ${insertedCount} record(s)`, 
                    'success'
                );
                
                // Refresh the data table
                fetchdata();
                setFile(null);
            }
            
            // CASE 2: Partial success (some rows inserted, some failed)
            else if (insertedCount > 0 && failedCount > 0) {
                showSnackbar(
                    `Partial upload: ${insertedCount} of ${totalRows} record(s) added successfully. ` +
                    `${failedCount} record(s) failed. Downloading error file...`,
                    'warning',
                    6000 // Show for 6 seconds
                );
                
                // Download error file
                if (data.error_file && data.error_file.content_base64) {
                    downloadBase64Excel(
                        data.error_file.content_base64, 
                        data.error_file.filename
                    );
                } else {
                    console.warn('No error file in response despite failed rows');
                }
                
                // Refresh the data table (to show successfully inserted rows)
                fetchdata();
                // Don't clear the file - user might want to fix and re-upload
            }
            
            // CASE 3: Complete failure (all rows failed)
            else if (insertedCount === 0 && failedCount > 0) {
                showSnackbar(
                    `Upload failed: All ${failedCount} record(s) have validation errors. ` +
                    `Downloading error file with details...`,
                    'error',
                    6000
                );
                
                // Download error file
                if (data.error_file && data.error_file.content_base64) {
                    downloadBase64Excel(
                        data.error_file.content_base64, 
                        data.error_file.filename
                    );
                } else {
                    console.warn('No error file in response despite all rows failing');
                    // Fallback: show the message if available
                    if (data.message) {
                        showSnackbar(data.message, 'error', 8000);
                    }
                }
            }
            
            // CASE 4: Unexpected state (shouldn't happen but handle gracefully)
            else {
                showSnackbar(
                    data.message || 'Upload completed with unexpected result', 
                    'info'
                );
            }
            
            setLoading(false);
        }
        
        // ============================================================
        // HANDLE ERROR RESPONSE (non-200 status)
        // ============================================================
        else {
            const errorMsg = response.error || 'Upload failed';
            
            // Handle different error types
            if (typeof errorMsg === 'string') {
                showSnackbar(errorMsg, 'error');
            } else if (Array.isArray(errorMsg)) {
                // If backend returns array of errors
                const displayError = errorMsg.slice(0, 3).join('; ') + 
                    (errorMsg.length > 3 ? ` ... and ${errorMsg.length - 3} more errors` : '');
                showSnackbar(displayError, 'error');
            } else if (typeof errorMsg === 'object' && errorMsg.error) {
                showSnackbar(errorMsg.error, 'error');
            } else {
                showSnackbar('An error occurred during upload', 'error');
            }
            
            setLoading(false);
        }
        
    } catch (error) {
        // This catches any unexpected errors in the frontend code
        console.error('Upload error:', error);
        showSnackbar('An unexpected error occurred. Please try again.', 'error');
        setLoading(false);
    }
};


  const submitdelete = async (id) => {
    setLoading(true);
    try {
      const response = await dispatch(multiDeleteHolidays(id));
      if (response.success == true) {
        showSnackbar(response.message.message, 'success');
        setLoading(false);
        fetchdata();
        setActionChecked("delete");
      } else {
        showSnackbar(response.message, 'warning');
        setLoading(false);
      }
    } catch (error) {
      showSnackbar('An error occurred', 'error');
      setLoading(false);
    }

  }

  const handleSaveClick = async (e) => {
    const holName = editedValues.hol_name?.trim();
    console.log("holName",holName);
    const holRegex = /^[^0-9@]+$/
    if (!holName){
      showSnackbar("Holiday Name cannot be empty.","warning");
      return;
    }
    else if (holName && !holRegex.test(holName)){
      showSnackbar("Enter a valid Holiday Name. Numbers and the “@” symbol are not allowed.","warning");
      return;
    }
    const holYear = editedValues.current_year?.trim();
    const holYearRegex = /^\d{4}$/;

    if (!holYear){
      showSnackbar("Current Year Cannot Be Empty","warning");
      return;
    }
    else if (holYear && !holYearRegex.test(holYear)){
      showSnackbar("Current Year must be exactly 4 digits (e.g., 2025).","warning");
      return;
    }
    setLoading(true);
    try {
      const response = await dispatch(updateHolidaysById(editedValues.id, editedValues));
      if (response.success == true) {
        showSnackbar(response.message, 'success');
        setLoading(false);
        setEditableRow(null);
        fetchdata();
      } else {
        showSnackbar(response.message, 'warning');
        setLoading(false);
      }
    } catch (error) {
      showSnackbar('An error occurred', 'error');
      setLoading(false);
    }
  };

  const handledeleteClickOpenalert = async (id) => {
    setLoading(true);
    try {
      const response = await dispatch(deleteHolidaysById(id));
      if (response.success == true) {
        showSnackbar(response.message, 'success');
        setLoading(false);
        setEditableRow(null);
        fetchdata();
        setActionChecked("delete");
      } else {
        showSnackbar(response.message, 'warning');
        setLoading(false);
      }
    } catch (error) {
      showSnackbar('An error occurred', 'error');
      setLoading(false);
    }
  };

  const getUserPermission = async () => {
    try {
        const response = await dispatch(getUserRole());
            const rawPermissions = response?.data?.permissions;
            const parsedPermissions = typeof rawPermissions === "string"
                ? JSON.parse(rawPermissions)
                : Array.isArray(rawPermissions) && typeof rawPermissions[0] === "string"
                ? JSON.parse(rawPermissions[0])
                : rawPermissions;
            parsedPermissions.forEach((item) => {
              if (item.section == "Configuration" && item.module == "Holidays") {
                          setCheckCreate(item.action.create);
                          setCheckEdit(item.action.edit);
                          setCheckDelete(item.action.delete);
    }});

    } catch (err) {
      console.error("Failed to fetch states:", err);
    }

};
useEffect(() => {
  getUserPermission();
}, [dispatch]);
  return (
    <div className='container-fluid'>
      {checkCreate &&
      <ImportFileform
        setFiledata={setFile}
        title={'Holiday'}
        filestemp={files}
        handleFileUpload={handleFileUpload}
        File={file}

      />}
      <EditableTable
      header={header}
      mainIcon={mainicon}
      title={'Holiday'}
      data={filteredData}
      setEditableRow={setEditableRow}
      setEditedValues={setEditedValues}
      handledeleteClickOpenalert={handledeleteClickOpenalert}
      editableRow={editableRow}
      setLoading={setLoading}
      editedValues={editedValues}
      getEditPermission = {checkEdit}
      getDeletePermission = {checkDelete}
      date={date}
      submitdelete={submitdelete}
      handleSaveClick={handleSaveClick}
      showSnackbar={showSnackbar}
      mainIconColor={"#c9dcff"}
      actionChecked={actionChecked}
      setActionChecked={setActionChecked}
      createOrfilterComp={
          <select className="formsTable_select_dropdown" value={selectedState}  onChange={filterstatewiseData} >
            <option value="" className='bg-light text-dark'>All State</option>
            {[...new Set(getData.map(item => item.hol_state))].sort((a, b) => a.localeCompare(b)).map((state, index) => (
              <option key={index} value={state} className='bg-light text-dark'>{state}</option>
            ))}
          </select>
      }
      />
      {/* <Reusabletable
        data={getData}
        header={header}
        setFile={setFile}
        handleFileUpload={handleFileUpload}
        submitdelete={submitdelete}
        handleSaveClick={handleSaveClick}
        setEditableRow={setEditableRow}
        editableRow={editableRow}
        setEditedValues={setEditedValues}
        editedValues={editedValues}
        handledeleteClickOpenalert={handledeleteClickOpenalert}
        title={'Holidays'}
        setLoading={setLoading}
        filestemp={files}
        showSnackbar={showSnackbar}
        getCreatePermission = {checkCreate}
        getEditPermission = {checkEdit}
        getDeletePermission = {checkDelete}
      /> */}
    </div>
  )
}


export default Holidays
